module.exports = __webpack_public_path__ + "img/product2_FF6B00_occupation.7ecd61dd.png";